import script from "./PaginationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationButtons.vue?vue&type=script&setup=true&lang=js"

import "./PaginationButtons.vue?vue&type=style&index=0&id=9ffb785e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ffb785e"]])

export default __exports__